import { KiteMark } from "@/components/Logo";

const ITEMS = ["Fly Higher. Together", "Revive. Reconnect. Rise.", "Same Wind. Different Kites. Endless Stories.", "Team Odisha"];

const Run = ({ items, ariaHidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
    {items.map((t, i) => (
      <span key={`${t}-${i}`} className="flex items-center">
        <span className="font-display font-bold text-paper/95 text-xl sm:text-2xl px-8 whitespace-nowrap">{t}</span>
        <KiteMark className="w-7 h-7 shrink-0" />
      </span>
    ))}
  </div>
);

const Marquee = ({ content }) => {
  const FALLBACK = ["Fly Higher. Together", "Revive. Reconnect. Rise.", "Same Wind. Different Kites. Endless Stories.", "Team Odisha"];
  const items = content?.marquee_items?.length ? content.marquee_items : FALLBACK;

  return (
    <section className="relative bg-navy" data-testid="marquee-section">
      <div className="h-[3px] bg-verm" />
      <div className="overflow-hidden py-4" data-testid="marquee-track">
        <div className="flex w-max animate-marquee">
          <Run items={items} />
          <Run items={items} ariaHidden />
        </div>
      </div>
      <div className="h-[3px] bg-verm" />
    </section>
  );
};

export default Marquee;
